import { gql } from "apollo-boost";

const BULK_PARTIAL_EDIT_UPLOAD = gql`
  mutation bulkPartialEditProductUpload($input: ProductEditUpload) {
    bulkPartialEditProductUpload(input: $input) {
      status
      data
      error
    }
  }
`;

export default BULK_PARTIAL_EDIT_UPLOAD;
